import { QueueAction } from './QueueAction';
import { QueueScheduler } from './QueueScheduler';
export var queue = new QueueScheduler(QueueAction);
//# sourceMappingURL=queue.js.map